<template>
  <div>
    <component
      ref="linkRef"
      v-if="value?.lotName || row?.lotsNumber === 1"
      :is="isLink ? 'a' : 'span'"
      v-bind="
        isLink
          ? { href: linkForLot, target: '_blank', rel: 'noopener noreferrer' }
          : {}
      "
      class="lot-cell-link"
      v-html="highlight()"
      draggable="false"
      @click="handleClick($event)"
    />
    <button
      v-else
      class="all-lots-button"
      @click="openOtherLotsModal"
      type="button"
    >
      <span class="name"> Лотов в закупке</span>
      <span class="lots-count">{{ row.proposalName.lotsNumber }}</span>
    </button>
  </div>
</template>

<script>
import { highlightSubstring } from "@/utils/highlightSubstring";
import { OtherLotsModalProperties } from "@/utils/modalsProperties";
import OtherLotsModal from "../OtherLotsModal.vue";
import { exceptionSelectionMixin } from "@/mixins/exceptionSelectionMixin";

export default {
  name: "LotCell",
  mixins: [exceptionSelectionMixin],
  props: ["value", "row", "column"],

  methods: {
    highlight() {
      return highlightSubstring(
        this.value?.lotName,
        this.currentTab.searchCriteria.keyWords,
      );
    },
    openOtherLotsModal() {
      this.$modal.show(
        OtherLotsModal,
        {
          row: this.row,
        },
        OtherLotsModalProperties,
      );
    },
    handleClick(e) {
      const selection = window.getSelection();
      if (selection && selection.toString().trim().length > 0) {
        e.preventDefault();
      }
    },
  },

  computed: {
    isLink() {
      return this.$store.getters["auth/authorities"]?.includes(
        "ROLE_SUBSCRIBED_USER",
      );
    },

    linkForLot() {
      const value = this.value;

      if (!value || typeof value !== "object") {
        return "#";
      }

      const { url, proposalSource, proposalNumber } = value;

      if (!url) {
        return "#";
      }

      try {
        const newUrl = new URL(url);

        const sources = [
          "https://sapsrm.beloil.by",
          "https://zakupki.minsktrans.by",
          "https://belaruskali.by",
          "https://belarus-tr.gazprom.ru",
        ];

        if (sources.includes(proposalSource) && proposalNumber) {
          newUrl.searchParams.append("number", proposalNumber);
        }

        return newUrl.href;
      } catch (e) {
        console.warn("Invalid lot URL:", value, e);
        return "#";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lot-cell-link {
  color: rgb(55, 71, 79);
  cursor: text;
  user-select: text;

  &::selection {
    background-color: #4766cb;
    color: #fff;
  }

  &:visited {
    color: rgb(159, 173, 181);
  }
}

.all-lots-button {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 2px 2px 2px 10px;
  height: 24px;
  background: #7e909b;
  border-radius: 20px;

  .name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
    line-height: 20px;
    color: #fff;
  }

  .lots-count {
    flex-shrink: 0;
    padding: 0 10px;
    min-height: 20px;
    line-height: 20px;
    background: #edeff1;
    border-radius: 10px;
    color: #7d919b;
  }
}
</style>
